<form [formGroup]="workflowgroup" (ngSubmit)="onSave()" class="wf-form" id="wf_action_dialog_id">

    <h2 mat-dialog-title class="wf-dialog-header">
        <span class="wf-dialog-title">{{ dialogTitle }}</span>
        <button class="wf-dialog-close" mat-dialog-close type="button" aria-label="Close">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#666" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
        </button>
    </h2>

    <div class="wf-dialog-divider"></div>

    <mat-dialog-content class="wf-dialog-content">

        <!-- Trigger Type — card-chip segmented control -->
        <div class="field">
            <mat-label>Trigger Type <span class="req">*</span></mat-label>
            <div class="wf-trigger-toggle" role="group" aria-label="Trigger type">

                <button type="button" class="wf-trigger-card-btn"
                    [class.active]="triggerTypeValue === 'schedule'"
                    data-kind="schedule"
                    (click)="selectTrigger('schedule')"
                    (keydown.enter)="selectTrigger('schedule')"
                    (keydown.space)="selectTrigger('schedule'); $event.preventDefault()">
                    <svg class="wf-trig-icon" viewBox="0 0 20 20" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <circle cx="10" cy="10" r="8.25" stroke="currentColor" stroke-width="1.5"/>
                        <path d="M10 6v4l2.5 2.5" stroke="currentColor" stroke-width="1.5"
                            stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <span class="wf-trig-label">Schedule</span>
                </button>

                <button type="button" class="wf-trigger-card-btn"
                    [class.active]="triggerTypeValue === 'event'"
                    data-kind="event"
                    (click)="selectTrigger('event')"
                    (keydown.enter)="selectTrigger('event')"
                    (keydown.space)="selectTrigger('event'); $event.preventDefault()">
                    <svg class="wf-trig-icon" viewBox="0 0 20 20" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path d="M11 2L4 11h7l-2 7 9-9h-7l2-8z" stroke="currentColor" stroke-width="1.5"
                            stroke-linejoin="round"/>
                    </svg>
                    <span class="wf-trig-label">Event</span>
                </button>

                <button type="button" class="wf-trigger-card-btn"
                    [class.active]="triggerTypeValue === 'manual'"
                    data-kind="manual"
                    (click)="selectTrigger('manual')"
                    (keydown.enter)="selectTrigger('manual')"
                    (keydown.space)="selectTrigger('manual'); $event.preventDefault()">
                    <svg class="wf-trig-icon" viewBox="0 0 20 20" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path d="M7 3.5C7 2.67 7.67 2 8.5 2S10 2.67 10 3.5V10m0 0V7.5c0-.83.67-1.5 1.5-1.5S13 6.67 13 7.5V10m0 0V8.5c0-.83.67-1.5 1.5-1.5S16 7.67 16 8.5v4A5 5 0 0 1 6 15l-2.5-3.5a1.5 1.5 0 0 1 2.4-1.8L7 11V3.5z"
                            stroke="currentColor" stroke-width="1.5"
                            stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <span class="wf-trig-label">Manual</span>
                </button>

            </div>
        </div>

        <!-- Event Type — only when Event is selected -->
        <ng-container *ngIf="isEvent">
            <div class="field">
                <mat-label>Event Type <span class="req">*</span></mat-label>
                <mat-form-field appearance="outline" class="full-width">
                    <mat-select formControlName="event_type_key">
                        <mat-option *ngFor="let e of eventTypes" [value]="e.value">{{ e.label }}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </ng-container>

        <!-- Workflow Name -->
        <div class="field">
            <mat-label>Workflow Name <span class="req">*</span></mat-label>
            <mat-form-field appearance="outline" class="full-width">
                <input matInput formControlName="wf_name" placeholder="Enter workflow name" />
            </mat-form-field>
        </div>

        <!-- Description -->
        <div class="field">
            <mat-label>Description</mat-label>
            <mat-form-field appearance="outline" class="full-width">
                <textarea matInput formControlName="description" rows="2"
                    placeholder="Optional description"></textarea>
            </mat-form-field>
        </div>

        <!-- Schedule fields — only when Schedule is selected -->
        <ng-container *ngIf="isSchedule">
            <div class="field-row">
                <div class="field">
                    <mat-label>Frequency <span class="req">*</span></mat-label>
                    <mat-form-field appearance="outline" class="full-width">
                        <mat-select formControlName="frequency">
                            <mat-option *ngFor="let f of frequencies" [value]="f">{{ f }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="field">
                    <mat-label>Time</mat-label>
                    <mat-form-field appearance="outline" class="full-width">
                        <mat-select formControlName="time" placeholder="Pick a time">
                            <mat-option *ngFor="let opt of frequencyTimeOptions" [value]="opt.value">
                                {{ opt.label }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="field">
                    <mat-label>Timezone</mat-label>
                    <mat-form-field appearance="outline" class="full-width">
                        <mat-select formControlName="timezone">
                            <mat-option *ngFor="let tz of timezones" [value]="tz">{{ tz }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
        </ng-container>

        <!-- Context-sensitive info box -->
        <div class="wf-info-box">
            <svg class="wf-info-icon-svg" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="10" cy="10" r="8.25" stroke="currentColor" stroke-width="1.5"/>
                <path d="M10 9v5M10 7v.5" stroke="currentColor" stroke-width="1.5"
                    stroke-linecap="round"/>
            </svg>
            <div class="wf-info-body">

                <!-- Default — no trigger selected yet -->
                <ng-container *ngIf="!triggerTypeValue">
                    <span class="wf-info-title">How Workflows Work</span>
                    <p class="wf-info-text">
                        Workflows automate patient journey cases. Choose a trigger type above —
                        Schedule runs on a time cadence, Event reacts to patient milestones,
                        and Manual lets a user initiate the flow on demand.
                    </p>
                </ng-container>

                <!-- Schedule examples -->
                <ng-container *ngIf="isSchedule">
                    <span class="wf-info-title">Schedule Workflow Examples</span>
                    <ul class="wf-info-list">
                        <li>Send daily Benefits Investigation summary report to the case team at 8 AM EST</li>
                        <li>Run weekly Prior Authorization status check every Monday and notify coordinators</li>
                        <li>Monthly PAP eligibility review on the 1st — auto-generate patient outreach cases</li>
                    </ul>
                </ng-container>

                <!-- Event examples -->
                <ng-container *ngIf="isEvent">
                    <span class="wf-info-title">Event-Triggered Workflow Examples</span>
                    <ul class="wf-info-list">
                        <li>PEF received → Auto-create intake case and alert the assigned coordinator</li>
                        <li>PA denied → Queue appeal review case and send notification to the case manager</li>
                        <li>PAP determination made → Trigger patient notification email and update journey stage</li>
                    </ul>
                </ng-container>

                <!-- Manual examples -->
                <ng-container *ngIf="isManual">
                    <span class="wf-info-title">Manual Trigger Workflow Examples</span>
                    <ul class="wf-info-list">
                        <li>Clinical team manually initiates a therapy override review for complex cases</li>
                        <li>Case manager triggers an exception workflow when standard rules don't apply</li>
                        <li>Supervisor runs an ad-hoc compliance audit on a specific patient cohort</li>
                    </ul>
                </ng-container>

            </div>
        </div>

    </mat-dialog-content>

    <!-- Action Buttons -->
    <mat-dialog-actions class="wf-actions">
        <button type="button" class="scraii-secondary-btn" mat-dialog-close>Cancel</button>
        <button type="submit" class="scraii-primary-btn" [disabled]="!canSubmit">Create</button>
    </mat-dialog-actions>

</form>
